import { TemplateEditViews } from 'modules/templateEditor/common';

export enum ConsumingApp {
  JOURNEY_STUDIO = 'JourneyStudio',
  CAMPAIGN_EDITOR = 'CampaignEditor',
  EXPERIMENT_TAKEOVER = 'ExperimentTakeover',
}

export interface TemplateEditState {
  /** Is the editor open? */
  isOpen?: boolean;
  /** The view being shown */
  view?: TemplateEditViews;
}

export type SetTemplateEditStateFn = (state: TemplateEditState) => void;

export interface InStudioTemplateProps {
  templateId?: number | null;
  onTemplateIdChange?: (id?: number | null) => void;
  campaignId?: number | null;
  onCampaignIdChange?: (id?: number | null) => void;
  view?: TemplateEditViews | string;
  messageMedium?: string;
  onViewChange?: (view?: TemplateEditViews | string) => void;
  consumingApp?: ConsumingApp;
  currentLocale?: string;
  setCurrentLocale?: (locale: string) => void;
}
